import React, { useState } from "react";
import Dialog from "../../../GenericComponents/dialog";
import { AddOneWorkspace } from '../../../Types/HomePageInterface';
import { useAddWorkSpaceMutation } from "../../../Redux/Home/HomeWorkspaceSlice";
import { getBaseUrl } from "../../../Utils";
import { useNavigate } from "react-router-dom";
import { FoundationsGenericToaster } from "../../../GenericComponents/FoundationsGenericToaster";

interface AddWorkspaceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  AddWorkSpaceCallBack?:any;
}

const AddWorkspaceDialog: React.FC<AddWorkspaceDialogProps> = ({ isOpen, onClose, AddWorkSpaceCallBack }) => {
  const [WorkspaceName, setWorkspaceName] = useState("");
  const [WorkspaceDescription, setWorkspaceDescription] = useState("");
  const [WorkspacePrivacy, setWorkspacePrivacy] = useState(0);
  const [AddWorkspaceErrorName, setAddWorkspaceErrorName] = useState("");
  const [AddWorkspaceErrorDesc, setAddWorkspaceErrorDesc] = useState("");
  const [AddNewWorkspaceData] = useAddWorkSpaceMutation();
  const baseUrl = `${getBaseUrl()}ux/index.html#workspace/`;
  const navigate = useNavigate();
  const[isLoading, setIsLoading] = useState(false);

  const resetForm = () => {
    setWorkspaceName("");
    setWorkspaceDescription("");
    setWorkspacePrivacy(0);
    setAddWorkspaceErrorName("");
    setAddWorkspaceErrorDesc("");
  };

    function CallAddNewWorkspaceData(AddOneWorkspacePayload: AddOneWorkspace) {
      setIsLoading(true);
      AddNewWorkspaceData(AddOneWorkspacePayload)
        .unwrap()
        .then(response => {
          const result = JSON.parse(JSON.stringify(response));
          setIsLoading(false);
          if (result.statusCode === 201) {
            if (result.data.Status.status == "Success") {
              FoundationsGenericToaster("success", result.data.MessageResults[0].Message);
              navigate(`#workspace/${result.data.Guid}`, { replace: true });
              onClose();
              resetForm();
              AddWorkSpaceCallBack([result.data])
            } else {
              FoundationsGenericToaster("error", result.data.MessageResults[0].Message);
            }
          } else {
            FoundationsGenericToaster("error", result.data.MessageResults[0].Message);
          }
        })
        .catch(error => {
          FoundationsGenericToaster("error", error);
          setIsLoading(false);
          // Handle error if needed
        });
  
    }

  function addNewWorkspace(newWorkspace: AddOneWorkspace) {
    // setWorkspaceName(newWorkspace.Name)
    // setWorkspaceDescription(newWorkspace.Description)
    // setWorkspacePrivacy(newWorkspace.PrivacyLock)

    //  FP-10792 Clear any previous validation messages
    setAddWorkspaceErrorName("");
    setAddWorkspaceErrorDesc("");
    
    if (newWorkspace.Name === "") {
      setAddWorkspaceErrorName("Workspace name cannot be empty. Please provide a workspace name.");
      return;
    }
    if (newWorkspace.Name.trim() === "") {
      setAddWorkspaceErrorName(""); // FP-10792 Make sure validation message is cleared
      FoundationsGenericToaster('error', 'Workspace name cannot be empty.')
      return;
    }
    if (WorkspaceDescription.length >= 256) {
      setAddWorkspaceErrorDesc("Workspace description cannot have more than 255 characters.")
      return;
    }

    const AddOneWorkspacePayload: AddOneWorkspace = {
      Name: newWorkspace.Name.trim(),
      Description: newWorkspace.Description,
      PrivacyLock: newWorkspace.PrivacyLock
    }

    CallAddNewWorkspaceData(AddOneWorkspacePayload)
  };

  return (
    <Dialog
      isOpen={isOpen}
      title="Add New Workspace"
      onClose={() => { onClose(); resetForm(); }}
      buttons={[
        {
          label: 'Cancel',
          onClick: () => {
            onClose();
            resetForm();
          }, 
          className: 'btn-secondary ui-button ui-corner-all ui-widget app-button negative'
        },
        { 
          label: 'Add Workspace', 
          onClick: () => addNewWorkspace({ Name: WorkspaceName, Description: WorkspaceDescription, PrivacyLock: WorkspacePrivacy }), 
          className: 'btn-primary ui-button ui-corner-all ui-widget app-button' 
        },
      ]}
      width={'462px'}
      height={'auto'}
    >
      <table className="input-form-table-popup-window">
        <tbody>
          <tr>
            <td className="left" style={{ width: "25%" }}>
              Name:
            </td>
            <td className="right">
              <input
                id="text_add_dashboard_name"
                className="field-add-new-dashboard"
                type="text"
                size={40}
                maxLength={50}
                value={WorkspaceName}
                onChange={(e) => setWorkspaceName(e.target.value)}
              />
              <div
                id="valmsg_text_add_dashboard_name"
                className="field-validation-error"
                style={{ 
                  display: AddWorkspaceErrorName ? "block" : "none",
                  width: "306px",
                 }}
              >
                {AddWorkspaceErrorName}
              </div>
            </td>
          </tr>
          <tr>
            <td className="left">Description:</td>
            <td className="right">
              <textarea
                id="text_add_dashboard_description"
                className="field-add-new-dashboard"
                style={{
                  border: '1px solid rgb(118, 118, 118)',
                  boxSizing: 'border-box',
                  height: '143px',
                }}
                cols={40}
                rows={6}
                value={WorkspaceDescription}
                onChange={(e) => setWorkspaceDescription(e.target.value)}
              ></textarea>
              <div
                id="valmsg_text_add_dashboard_Description"
                className="field-validation-error"
                style={{ 
                  display: AddWorkspaceErrorDesc ? "block" : "none",
                  width: "306px",
                 }}
              >
                {AddWorkspaceErrorDesc}
              </div>
            </td>
          </tr>
          <tr>
            <td className="left">Access Level:</td>
            <td className="right">
              <select
                id="list_dashboard_add_privacy_lock"
                size={1}
                className="field-auto-refresh w-100"
                value={WorkspacePrivacy}
                onChange={(e) => setWorkspacePrivacy(Number(e.target.value))}
              >
                <option value={0}>Open, changes allowed</option>
                <option value={1}>Shared lock, restricted updates</option>
                <option value={2}>
                  Locked, only for me and administrators
                </option>
              </select>
              <div
                id="valmsg_list_dashboard_add_privacy_lock"
                className="field-validation-error"
                style={{ display: "none" }}
              ></div>
            </td>
          </tr>
        </tbody>
      </table>
      <span
        id="add_dashboard_loading"
        className={`ajax-loading-box popup-loading ${isLoading ? "" : "hide"}`}
      >
        <span className="ajax-loading-image">Adding...</span>
      </span>
    </Dialog>
  );
};

export default AddWorkspaceDialog;